
//公共目录 项目价格 接口相关的函数
import request from "../../untils/request.js"

/**
 *
 *  post
 *
 */

//查询给药方式
export const getMedicationFrequency = (params) => {
    return request.get("/outpatient/getMedicationFrequency", { params })
}

//查询给药方式
export const getCosruteItemData = (params) => {
    return request.get("/outpatient/cosrute/get", { params })
}


//查询项目价格
export const getChargingPrice = (params) => {
    return request.get("/outpatient/costnametable/list", { params })
}

//给药方式费用关联中间表-保存
export const addCosrute = (data) => {
    return request.post("/outpatient/cosrute", data)
}

//给药方式费用关联中间表-获取
export const getCosrute = (params) => {
    return request.get("/outpatient/cosrute/get", { params })
}

//给药方式费用关联中间表-修改
export const updateCosrute = (data) => {
    return request.put("/outpatient/cosrute", data)
}

//给药方式费用关联中间表-删除
export const deleteCosrute = (params) => {
    return request.get("/outpatient/cosrute/delete", {params})
}

//给药方式新增
export const addCosruteForm = (data) => {
    return request.post("/outpatient/docrute", data)
}

//给药方式修改
export const editCosruteForm = (data) => {
    return request.put("/outpatient/docrute", data)
}

//本科室给药方式分页
export const loadMyClinicData = (params) => {
    return request.get("/outpatient/docrute/page", {params})
}


// 暴露
export default{
    getMedicationFrequency,getCosruteItemData,getChargingPrice,addCosrute,getCosrute
}